import { formatDate } from "../../../../utils/helpers";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const TopContentCampaign = ({
  banner_images,
  logo,
  title,
  description,
  location,
  date,
  isSignificant,
}) => {
  const hasMultiple = banner_images?.length > 1;

  return (
    <div data-aos="fade-up" className="w-full">
      {!isSignificant && (
        <div
          className="w-full rounded-lg overflow-hidden"
          data-aos="zoom-in"
          data-aos-delay="100"
        >
          {hasMultiple ? (
            <Swiper
              className="rounded-lg w-full h-64 sm:h-80 md:h-96 lg:h-[32rem] overflow-hidden shadow-lg campaign-swiper"
              modules={[Navigation, Pagination, Autoplay]}
              navigation={{
                enabled: window.innerWidth >= 768, // Enable navigation only on desktop
              }}
              pagination={{
                clickable: true,
                dynamicBullets: true,
                dynamicMainBullets: 3,
              }}
              autoplay={{
                delay: 4000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              loop
              speed={800}
              breakpoints={{
                320: {
                  navigation: {
                    enabled: false,
                  },
                },
                768: {
                  navigation: {
                    enabled: true,
                  },
                },
              }}
            >
              {banner_images.map((img, index) => (
                <SwiperSlide key={index} className="h-full w-full">
                  <img
                    src={img}
                    alt=""
                    className="w-full h-full object-cover object-center transition-transform duration-300 hover:scale-105"
                    loading={index === 0 ? "eager" : "lazy"}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          ) : (
            banner_images?.[0] && (
              <div className="relative overflow-hidden rounded-lg shadow-lg">
                <img
                  src={banner_images[0]}
                  alt="Campaign banner"
                  className="w-full h-64 sm:h-80 md:h-96 lg:h-[32rem] object-cover object-center rounded-lg transition-transform duration-300 hover:scale-105"
                  loading="eager"
                />
              </div>
            )
          )}
        </div>
      )}

      {/* Location and date */}
      <div
        className="my-3 sm:my-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 sm:gap-4 font-semibold text-amber-600"
        data-aos="fade-right"
        data-aos-delay="200"
      >
        {!isSignificant && (
          <span className="text-sm sm:text-base flex items-center">
            <svg
              className="w-4 h-4 mr-2 flex-shrink-0"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                clipRule="evenodd"
              />
            </svg>
            {formatDate(date)}
          </span>
        )}

        {location && (
          <span className="text-sm sm:text-base flex items-center">
            <svg
              className="w-4 h-4 mr-2 flex-shrink-0"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                clipRule="evenodd"
              />
            </svg>
            {location}
          </span>
        )}
      </div>

      <div className="mb-4 flex items-center">
        {logo && (
          <div className="mb-4 flex items-center">
            <img
              src={logo}
              alt="campaign logo"
              className="w-16 h-16 sm:w-20 sm:h-20 object-contain rounded-full border shadow-sm bg-white p-1"
            />
          </div>
        )}
      </div>

      {/* Title */}
      <div
        className="my-4 sm:my-5"
        // data-aos="fade-up" data-aos-delay="250"
      >
        <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold tracking-wide font-onest leading-tight text-gray-900">
          {title}
        </h1>
      </div>

      {/* DESCRIPTION */}
      <div className="text-sm sm:text-base text-gray-700 tracking-wide leading-relaxed">
        <p className="break-words whitespace-pre-wrap">
          <div dangerouslySetInnerHTML={{ __html: description }}></div>
        </p>
      </div>
    </div>
  );
};

export default TopContentCampaign;
